export default theme => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  rowUnread: {
    backgroundColor: '#c4ceff',
    '&:hover': {
      backgroundColor: '#c4ceff',
    },
  },
  rowRoot: {
    height: 36,
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  texts: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    // marginRight: theme.spacing.unit,
    maxWidth: 400,
    whiteSpace: 'pre-wrap',
  },
  text: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 2, /* number of lines to show */
    lineHeight: '16px',        /* fallback */
    maxHeight: '32px',       /* fallback */
  },
  seeMoreButton: {
    left: '50%',
    transform: 'translateX(-50%)',
  },
});



// WEBPACK FOOTER //
// ./src/modules/notification/NotificationButton/styles.js